const accountUsageStyles = {
  circularProgressPercentageBox: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  planPriceBox: {
    backgroundColor: "#F4F1FC",
    p: 2.5,
    display: "flex",
    flexDirection: {
      xs: "column",
      sm: "row",
    },
    justifyContent: "space-between",
  },
  planPrice: {
    fontSize: "24px !important",
    lineHeight: "0.9 !important",
    fontWeight: 700,
  },
  planPriceText: {
    display: "flex",
    alignItems: "flex-end",
    textTransform: "none",
  },
  featureNameStack: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  featuresMainGridItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 5,
  },
  sendBtn: {
    width: "7.125rem",
    height: "2.5rem",
  },
};

export default accountUsageStyles;
